import { UserConstants } from '../constants';

let initialState = { uCertificates: [], uCertificatesExist: false, uCertificatesLoading: false, uCertificatesErr: '' };
export function get_unconfirmed(state = initialState, action) {
    switch (action.type) {
    case UserConstants.UNCONFIRMED_SUCCESS:
        return {
            uCertificates: action.payload.data,
            uCertificatesExist: true,
            uCertificatesLoading: false,
            uCertificatesErr: '',
        };
    case UserConstants.UNCONFIRMED_REQUEST:
        return {
            uCertificates: [],
            uCertificatesExist: false,
            uCertificatesLoading: true,
            uCertificatesErr: '',
        };
    case UserConstants.UNCONFIRMED_ERROR:
        return {
            uCertificates: [],
            uCertificatesExist: false,
            uCertificatesLoading: false,
            uCertificatesErr: action.payload.message,
        };
    case UserConstants.CONFIRM_CERTIFICATE:
        state.uCertificates.splice(action.payload,1);
        return {
            uCertificates: state.uCertificates,
            uCertificatesExist: true,
            uCertificatesLoading: false,
            uCertificatesErr: '',
        };
    case UserConstants.DELETE_CERTIFICATE:
        state.uCertificates.splice(action.payload,1);
        return {
            uCertificates: state.uCertificates,
            uCertificatesExist: true,
            uCertificatesLoading: false,
            uCertificatesErr: '',
        };

    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/UnconfirmedReducer.jsx